import { Accordion, Label, LoadingWrapper, Tooltip } from 'client/CommonComponents';
import './AssetItemStatus.scss';
import PurchaseDetail from './PurchaseDetail'
import DealerDetail from './DealerDetail';
import PurchaseOrder from './PurchaseOrder';
import Task from './Task';
import Moment from 'moment';
import { formatPrice } from 'utils';

const AssetItemStatus = (props?: any) => {
    const {
        fleetRequestDetailId,
        assetItemStatusHeaderDetail,
        onChangeAccordian,
        assetItemStatusTemp,
        skipVendorDetail,
        isBulkOrder,
        getDateAndStatus,
        isAssetItemStatusPurchaseDetailsCalled,
        isAssetItemStatusPurchaseOrderCalled,
        isAssetItemStatusVendorDetailCalled,
        isAssetItemStatusTaskDetailCalled
    }: any = props

    const ExpandedItems = [
        {
            headerText: <div className={`accordionHeader ${getDateAndStatus("Status", "PurchaseDetail") == "In Progress" ? "Pending" : getDateAndStatus("Status", "PurchaseDetail") == "Not Started" ? "Inactive" : "Approved"} `}>
                <p className='heading-txt'>Purchase Detail</p>
                {getDateAndStatus("Date", "PurchaseDetail") ?
                    <p className='subheading-txt'>Date Completed {Moment(getDateAndStatus("Date", "PurchaseDetail")).format('MM/DD/YYYY')}</p>
                    : null}
            </div>,
            content: <PurchaseDetail assetItemStatusTemp={assetItemStatusTemp} skipVendorDetail={skipVendorDetail} isLoading={isAssetItemStatusPurchaseDetailsCalled(fleetRequestDetailId)} /> ,
            uuid: `purchaseDetail`
        },
        {
            headerText: <div className={`accordionHeader ${getDateAndStatus("Status", "DealerDetail") == "In Progress" ? "Pending" : getDateAndStatus("Status", "DealerDetail") == "Not Started" ? "Inactive" : "Approved"} `}>
                <p className='heading-txt'>{isBulkOrder ? "Vendor Detail" : "Dealer Detail"}</p>
                {getDateAndStatus("Date", "DealerDetail") ?
                    <p className='subheading-txt'>Date Completed {Moment(getDateAndStatus("Date", "DealerDetail")).format('MM/DD/YYYY')}</p>
                    : null}
            </div>,
            content:  <DealerDetail assetItemStatusTemp={assetItemStatusTemp} isBulkOrder={isBulkOrder} isLoading={isAssetItemStatusVendorDetailCalled(fleetRequestDetailId)}/>,
            uuid: `vendorDetail`
        },
        {
            headerText: <div className={`accordionHeader ${getDateAndStatus("Status", "PurchaseOrder") == "In Progress" ? "Pending" : getDateAndStatus("Status", "PurchaseOrder") == "Not Started" ? "Inactive" : "Approved"} `}>
                <p className='heading-txt'>Purchase Order</p>
                {getDateAndStatus("Date", "PurchaseOrder") ?
                    <p className='subheading-txt'>Date Completed {Moment(getDateAndStatus("Date", "PurchaseOrder")).format('MM/DD/YYYY')}</p>
                    : null}
            </div>,
            content: <PurchaseOrder assetItemStatusTemp={assetItemStatusTemp} isLoading={isAssetItemStatusPurchaseOrderCalled(fleetRequestDetailId)} />,
            uuid: `purchaseOrder`
        },
        {
            headerText: <div className={`accordionHeader ${getDateAndStatus("Status", "TaskDetail") == "In Progress" ? "Pending" : getDateAndStatus("Status", "TaskDetail") == "Not Started" ? "Inactive" : "Approved"} `}>
                <p className='heading-txt'>Task</p>
                {getDateAndStatus("Date", "TaskDetail") ?
                    <p className='subheading-txt'>Date Completed {Moment(getDateAndStatus("Date", "TaskDetail")).format('MM/DD/YYYY')}</p>
                    : null}
            </div>,
            content: <Task assetItemStatusTemp={assetItemStatusTemp} isLoading={isAssetItemStatusTaskDetailCalled(fleetRequestDetailId)}/>,
            uuid: `taskdetail`
        }
    ]

    const SkipVendorExpandedItems = [
        {
            headerText: <div className={`accordionHeader ${getDateAndStatus("Status", "PurchaseDetail") == "In Progress" ? "Pending" : getDateAndStatus("Status", "PurchaseDetail") == "Not Started" ? "Inactive" : "Approved"} `}>
                <p className='heading-txt'>Purchase Detail</p>
                {getDateAndStatus("Date", "PurchaseDetail") ?
                    <p className='subheading-txt'>Date Completed {Moment(getDateAndStatus("Date", "PurchaseDetail")).format('MM/DD/YYYY')}</p>
                    : null}
            </div>,
            content: <PurchaseDetail assetItemStatusTemp={assetItemStatusTemp} skipVendorDetail={skipVendorDetail} isLoading={isAssetItemStatusPurchaseDetailsCalled(fleetRequestDetailId)} />,
            itemKey: `purchaseDetail`,
            uuid: `purchaseDetail`
        },
        {
            headerText: <div className={`accordionHeader ${getDateAndStatus("Status", "TaskDetail") == "In Progress" ? "Pending" : getDateAndStatus("Status", "TaskDetail") == "Not Started" ? "Inactive" : "Approved"} `}>
                <p className='heading-txt'>Task</p>
                {getDateAndStatus("Date", "TaskDetail") ?
                    <p className='subheading-txt'>Date Completed {getDateAndStatus("Date", "TaskDetail") ? Moment(getDateAndStatus("Date", "TaskDetail")).format('MM/DD/YYYY') : '-'}</p>
                    : null}
            </div>,
            content: <Task assetItemStatusTemp={assetItemStatusTemp} isLoading={isAssetItemStatusTaskDetailCalled(fleetRequestDetailId)}/>,
            itemKey: 'taskdetail',
            uuid: `taskdetail`
        }
    ]

    const getBulkOrderFields = () => {
        return (
            <>
                <div>
                    <Label data-attribute="AssetItemStatus_Default_Label">{assetItemStatusTemp?.headerDetails?.requestType == "Managed Equipment" ? "Equipment Type" : "Vehicle Type"}</Label>
                    <Tooltip content={assetItemStatusTemp?.headerDetails?.subType || '-'} data-attribute="AssetItemStatus_Default_Tooltip">
                        <div className="content">{assetItemStatusTemp?.headerDetails?.subType || '-'}</div>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetItemStatus_Default_Label_2">Make</Label>
                    <Tooltip content={assetItemStatusTemp?.headerDetails?.make || '-'} data-attribute="AssetItemStatus_Default_Tooltip_2">
                        <div className="content">{assetItemStatusTemp?.headerDetails?.make || '-'}</div>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetItemStatus_Default_Label_3">{assetItemStatusTemp?.headerDetails?.requestType == "Managed Equipment" ? "Equipment Spec" : "Vehicle Spec"}</Label>
                    <Tooltip content={assetItemStatusTemp?.headerDetails?.description || '-'} data-attribute="AssetItemStatus_Default_Tooltip_3">
                        <div className="content">{assetItemStatusTemp?.headerDetails?.description || '-'}</div>
                    </Tooltip>
                </div>
            </>
        )
    }

    const getRequisitionFields = () => {
        if (assetItemStatusTemp?.headerDetails?.subType == "Production Vehicle" || assetItemStatusTemp?.headerDetails?.subType == "Management Vehicle") {
            return (
                <>
                    <div>
                        <Label data-attribute="AssetItemStatus_Default_Label_4">Vehicle Type</Label>
                        <Tooltip content={assetItemStatusTemp?.headerDetails?.subType || '-'} data-attribute="AssetItemStatus_Default_Tooltip_4">
                            <div className="content">{assetItemStatusTemp?.headerDetails?.subType || '-'}</div>
                        </Tooltip>
                    </div>
                    {
                        assetItemStatusTemp?.headerDetails?.subType == "Production Vehicle" ?
                            <>
                                {assetItemStatusTemp?.headerDetails?.showVehicleCapacity &&
                                    <div>
                                        <Label data-attribute="AssetItemStatus_Default_Label_5">Vehicle Capacity</Label>
                                        <Tooltip content={assetItemStatusTemp?.headerDetails?.vehicleCapacity || '-'} data-attribute="AssetItemStatus_Default_Tooltip_5">
                                            <div className="content">{assetItemStatusTemp?.headerDetails?.vehicleCapacity || '-'}</div>
                                        </Tooltip>
                                    </div>
                                }
                                <div>
                                    <Label data-attribute="AssetItemStatus_Default_Label_6"># of Doors</Label>
                                    <Tooltip content={assetItemStatusTemp?.headerDetails?.noOfDoors || '-'} data-attribute="AssetItemStatus_Default_Tooltip_6">
                                        <div className="content">{assetItemStatusTemp?.headerDetails?.noOfDoors || '-'}</div>
                                    </Tooltip>
                                </div>
                                <div>
                                    <Label data-attribute="AssetItemStatus_Default_Label_7">Upfit</Label>
                                    <Tooltip content={assetItemStatusTemp?.headerDetails?.upfit || '-'} data-attribute="AssetItemStatus_Default_Tooltip_7">
                                        <div className="content">{assetItemStatusTemp?.headerDetails?.upfit || '-'}</div>
                                    </Tooltip>
                                </div>
                            </> : null
                    }
                    {
                        assetItemStatusTemp?.headerDetails?.subType == "Management Vehicle" ?
                            <>
                                <div>
                                    <Label data-attribute="AssetItemStatus_Default_Label_8">Driver Title</Label>
                                    <Tooltip content={assetItemStatusTemp?.headerDetails?.driverTitle || '-'} data-attribute="AssetItemStatus_Default_Tooltip_8">
                                        <div className="content">{assetItemStatusTemp?.headerDetails?.driverTitle || '-'}</div>
                                    </Tooltip>
                                </div>
                                <div>
                                    <Label data-attribute="AssetItemStatus_Default_Label_9">Driver Details</Label>
                                    <Tooltip content={assetItemStatusTemp?.headerDetails?.driverName || '-'} data-attribute="AssetItemStatus_Default_Tooltip_9">
                                        <div className="content">{assetItemStatusTemp?.headerDetails?.driverName || '-'}</div>
                                    </Tooltip>
                                </div>
                            </> : null
                    }
                    <div>
                        <Label data-attribute="AssetItemStatus_Default_Label_10">Drive Train</Label>
                        <Tooltip content={assetItemStatusTemp?.headerDetails?.driveTrain || '-'} data-attribute="AssetItemStatus_Default_Tooltip_10">
                            <div className="content">{assetItemStatusTemp?.headerDetails?.driveTrain || '-'}</div>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="AssetItemStatus_Default_Label_11">Fuel Type</Label>
                        <Tooltip content={assetItemStatusTemp?.headerDetails?.fuelType || '-'} data-attribute="AssetItemStatus_Default_Tooltip_11">
                            <div className="content">{assetItemStatusTemp?.headerDetails?.fuelType || '-'}</div>
                        </Tooltip>
                    </div>
                </>
            )
        } else if (assetItemStatusTemp?.headerDetails?.requestType == "Managed Equipment") {
            return (
                <>
                    <div>
                        <Label data-attribute="AssetItemStatus_Default_Label_12">Equipment Type</Label>
                        <Tooltip content={assetItemStatusTemp?.headerDetails?.subType || '-'} data-attribute="AssetItemStatus_Default_Tooltip_12">
                            <div className="content">{assetItemStatusTemp?.headerDetails?.subType || '-'}</div>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="AssetItemStatus_Default_Label_13">Description</Label>
                        <Tooltip content={assetItemStatusTemp?.headerDetails?.description || '-'} data-attribute="AssetItemStatus_Default_Tooltip_13">
                            <div className="content">{assetItemStatusTemp?.headerDetails?.description || '-'}</div>
                        </Tooltip>
                    </div>
                </>
            )
        } else {
            return (
                <>
                    <div>
                        <Label data-attribute="AssetItemStatus_Default_Label_14">Make</Label>
                        <Tooltip content={assetItemStatusTemp?.headerDetails?.make || '-'} data-attribute="AssetItemStatus_Default_Tooltip_14">
                            <div className="content">{assetItemStatusTemp?.headerDetails?.make || '-'}</div>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="AssetItemStatus_Default_Label_15">Model</Label>
                        <Tooltip content={assetItemStatusTemp?.headerDetails?.model || '-'} data-attribute="AssetItemStatus_Default_Tooltip_15">
                            <div className="content">{assetItemStatusTemp?.headerDetails?.model || '-'}</div>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="AssetItemStatus_Default_Label_16">Year</Label>
                        <Tooltip content={assetItemStatusTemp?.headerDetails?.year || '-'} data-attribute="AssetItemStatus_Default_Tooltip_16">
                            <div className="content">{assetItemStatusTemp?.headerDetails?.year || '-'}</div>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="AssetItemStatus_Default_Label_17">Used</Label>
                        <Tooltip content={assetItemStatusTemp?.headerDetails?.isUsed ? 'yes' : 'No'} data-attribute="AssetItemStatus_Default_Tooltip_17">
                            <div className="content">{assetItemStatusTemp?.headerDetails?.isUsed ? 'yes' : 'No'}</div>
                        </Tooltip>
                    </div>
                </>
            )
        }
    }


    return (
        <div className="asset-item-status-content">
            <div className="header-fleetbulk-block">
                <div className='fleetBulkAssetContent'>
                <div>
                    <Label data-attribute="AssetItemStatus_Default_Label_18">Item ID</Label>
                    <Tooltip content={assetItemStatusTemp?.headerDetails?.itemId || '-'} data-attribute="AssetItemStatus_Default_Tooltip_18">
                        <div className="content">{assetItemStatusTemp?.headerDetails?.itemId || '-'}</div>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetItemStatus_Default_Label_19">Request Type</Label>
                    <Tooltip content={assetItemStatusTemp?.headerDetails?.requestType || '-'} data-attribute="AssetItemStatus_Default_Tooltip_19">
                        <div className="content">{assetItemStatusTemp?.headerDetails?.requestType || '-'}</div>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetItemStatus_Default_Label_20">Cost Center</Label>
                    <Tooltip content={assetItemStatusTemp?.headerDetails?.costCenter || '-'} data-attribute="AssetItemStatus_Default_Tooltip_20">
                        <div className="content">{assetItemStatusTemp?.headerDetails?.costCenter || '-'}</div>
                    </Tooltip>
                </div>
                {
                    assetItemStatusTemp?.headerDetails?.isBulkOrder ?
                        getBulkOrderFields()
                        :
                        getRequisitionFields()
                }
                </div>
                <div className='fleetBulkAssetPrice'>
                    <Label data-attribute="AssetItemStatus_Default_Label_21">Price</Label>
                    <Tooltip content={`${assetItemStatusTemp?.headerDetails?.price ? `$ ${formatPrice(assetItemStatusTemp?.headerDetails?.price, 2)}` : "-"}`} data-attribute="AssetItemStatus_Default_Tooltip_21">
                        <div className="content">{`${assetItemStatusTemp?.headerDetails?.price ? `$ ${formatPrice(assetItemStatusTemp?.headerDetails?.price, 2)}` : "-"}`}</div>
                    </Tooltip>
                </div>
            </div>
            <div className="content-fleetbulk-block">
                <Accordion
                    Items={skipVendorDetail ? SkipVendorExpandedItems : ExpandedItems}
                    className='nested-bulkorder-fleet-accordion'
                    onChange={(item: any) => { onChangeAccordian(item) }}
                 data-attribute="AssetItemStatus_Default_Accordion" />
            </div>
        </div>
    )
}

export default AssetItemStatus;